import firebase from 'firebase';
import 'firebase/auth';

const app = firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

//     measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,

const googleProvider = new firebase.auth.GoogleAuthProvider();

export const googleAuth = googleProvider;
export const auth = app.auth();
export const storage = app.storage();
export default app;